module.exports = __webpack_public_path__ + "1f445f3b64cbea3a48dce622abc7b6d1.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/winking-24.png
// module id = 2391
// module chunks = 0